<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <router-link to="/dashboard">
      <div class="logo"><i class="ldms-font ldms-yiluniu" style="font-size: 32px;color: rgb(64, 157, 251)"></i>&nbsp;{{title}}</div>
    </router-link>
    <div class="collapse-btn" @click="collapseChage">
      <!-- <marquee onmouseover=this.stop() onmouseout=this.start()>匹配司机、车辆查询中如果出现<span style="color: red">红色</span>标记为自己上车的司机，请慎用！</marquee> -->
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 消息中心 -->
        <div class="btn-bell">
          <router-link to="/userMessage">
          <el-tooltip effect="dark" :content="message?`有${message}条未读消息`:`消息中心`" placement="bottom">
              <i class="el-icon-bell"></i>
          </el-tooltip>
          <span class="btn-bell-badge" v-if="message"></span>
          </router-link>
        </div>
        <!-- 用户头像 -->
        <div class="user-avator"><img :src="userInfo.user.head"></div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{userInfo.user.userName}} <i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/userInfo">
            <a>
              <el-dropdown-item>个人中心</el-dropdown-item>
            </a>
            </router-link>
            <router-link to="/dashboard">
            <a>
              <el-dropdown-item>个人应用</el-dropdown-item>
            </a>
            </router-link>
            <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getTotalMsg } from '@/api/message'

export default {
  props: {
    title: {
      default: '配货系统'
    }
  },
  data () {
    return {
      collapse: false,
      fullscreen: false,
      name: 'linxin',
      message: 0
    }
  },
  created () {
    let _this = this
    getTotalMsg().then(response => {
      _this.message = response.data.data
    })
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  },
  methods: {
    // 用户名下拉菜单选择事件
    handleCommand (command) {
      if (command === 'logout') {
        this.logOut({'router': this.$router})
      } else {
      }
    },
    // 侧边栏折叠
    collapseChage () {
      this.collapse = !this.collapse
    },
    ...mapActions({logOut: 'user/logOut'})
  },
  mounted () {
    if (document.body.clientWidth < 1500) {
      this.collapseChage()
    }
  }
}
</script>
<style scoped>
  .header {
    background-color: #334157;
    padding-top: 0;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
    z-index: 0;
  }
  .collapse-btn{
    float: left;
    padding: 0 21px;
    cursor: pointer;
    width: 70%;
    line-height: 70px;
  }
  .header .logo{
    float: left;
    width:180px;
    line-height: 70px;
    text-align: center;
  }
  .header-right{
    float: right;
    padding-right: 50px;
    padding-top: 0;
  }
  .header-user-con{
    display: flex;
    height: 70px;
    align-items: center;
  }
  .btn-fullscreen{
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
  }
  .btn-bell, .btn-fullscreen{
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
  }
  .btn-bell-badge{
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
  }
  .btn-bell .el-icon-bell{
    color: #fff;
  }
  .user-name{
    margin-left: 10px;
  }
  .user-avator{
    margin-left: 20px;
  }
  .user-avator img{
    display: block;
    width:40px;
    height:40px;
    border-radius: 50%;
  }
  .el-dropdown-link{
    color: #fff;
    cursor: pointer;
  }
  .el-dropdown-menu__item{
    text-align: center;
  }
</style>
